import './FileViewer.scss';
import React from 'react';
import clsx from 'clsx';
import { IDocument } from '@cyntler/react-doc-viewer/dist/models';
import DocViewer, {
    BMPRenderer,
    GIFRenderer,
    JPGRenderer,
    PNGRenderer,
    TIFFRenderer,
    VideoRenderer,
} from '@cyntler/react-doc-viewer';
import FatalError from '@molecules/FatalError';
import FatalErrorIcon from '@molecules/FatalError/FatalErrorIcon';
import Preloader from '@atoms/Preloader';
import PDFIFrameRenderer from './customRenderers/PDFIFrameRenderer/PDFIFrameRenderer';

export interface IFileViewerProps {
    /** Файлы */
    docs: IDocument[];
    /** Класс */
    className?: string;
    /** Номер первоначального активного документа */
    initialActiveDocumentNumber?: number;
    /** Колбэк при изменении документа */
    onDocumentChange?: (document: IDocument) => void;
}

const FileViewer = ({
    docs,
    className,
    initialActiveDocumentNumber = 0,
    onDocumentChange,
    ...props
}: IFileViewerProps) => {
    const NoRenderer = ({ document, fileName }: { document: IDocument | undefined; fileName: string }) => {
        return (
            <FatalError
                icon={<FatalErrorIcon variant="server" />}
                title="Просмотр данного типа файлов не поддерживается"
                description={''}
            />
        );
    };

    const LoadingRenderer = ({ document, fileName }: { document: IDocument | undefined; fileName: string }) => {
        return (
            <div className={'rf-file-viewer__loading'}>
                <Preloader size="l" label="Загрузка документа..." />
            </div>
        );
    };

    return (
        <div className={clsx('rf-file-viewer', className)}>
            <DocViewer
                documents={docs}
                initialActiveDocument={docs[initialActiveDocumentNumber]}
                pluginRenderers={[
                    BMPRenderer,
                    JPGRenderer,
                    PNGRenderer,
                    TIFFRenderer,
                    GIFRenderer,
                    VideoRenderer,
                    PDFIFrameRenderer,
                ]}
                language={'ru'}
                config={{
                    noRenderer: {
                        overrideComponent: NoRenderer,
                    },
                    loadingRenderer: {
                        overrideComponent: LoadingRenderer,
                    },
                }}
                onDocumentChange={(document) => {
                    onDocumentChange && onDocumentChange(document);
                }}
            />
        </div>
    );
};

export default React.memo(FileViewer);
